import { render, staticRenderFns } from "./PriorityDetailModal.vue?vue&type=template&id=d148c41a&scoped=true&"
import script from "./PriorityDetailModal.vue?vue&type=script&lang=js&"
export * from "./PriorityDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./PriorityDetailModal.vue?vue&type=style&index=0&id=d148c41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d148c41a",
  null
  
)

export default component.exports